function NoShowsReport() {
    return (
      <>
        <div className="font-bold text-lg mb-16">NoShowsReport</div>
      </>
    );
  }
  
  export default NoShowsReport;